<template>
  <div class="h5-container">
    <!-- 顶部导航栏：保留原有风格 -->
    <van-nav-bar
        class="top-bar"
        title="忘记密码"
        left-text="返回"
        left-arrow
        @click-left="onClickLeft"
    ></van-nav-bar>

    <!-- 密码重置表单：保留原有样式 -->
    <div class="form-wrap">
      <van-form @submit="onSubmit" ref="forgotPwdForm">
        <!-- 手机号输入框：始终显示 -->
        <div class="phone-tip">港澳台手机号必须带对应区号（如+852/+853/+886）</div>
        <van-field
            v-model="formData.phoneNumber"
            name="phoneNumber"
            label="手机号"
            placeholder="请输入手机号"
            type="tel"
            clearable
            required
            :readonly="step === 2"
            :rules="[{ required: true}, { pattern: mobileReg, message: '请输入合法的手机号' }]"
        />

        <!-- 验证码输入框 + 获取验证码按钮：始终显示 -->
        <!-- 验证码输入框 + 获取验证码按钮：仅第一步显示【修改点2】 -->
        <van-field
            v-if="step === 1"
            v-model="formData.code"
            name="code"
            label="验证码"
            placeholder="请输入6位验证码"
            clearable
            required
            :rules="[{ required: true, trigger: 'blur' }, { len: 6, message: '验证码为6位数字', trigger: 'blur' }]"
        >
          <template #button>
            <van-button
                size="small"
                type="primary"
                :disabled="countDown > 0 || !isMobileValid"
                @click="getVerifyCode"
                class="code-btn"
            >
              {{ countDown > 0 ? `${countDown}s后重新获取` : '获取验证码' }}
            </van-button>
          </template>
          <template #button>
            <van-button
                size="small"
                type="primary"
                :disabled="countDown > 0 || !isMobileValid"
                @click="getVerifyCode"
                class="code-btn"
            >
              {{ countDown > 0 ? `${countDown}s后重新获取` : '获取验证码' }}
            </van-button>
          </template>
        </van-field>

        <!-- 新密码：第二步才显示 -->
        <van-field
            v-if="step === 2"
            v-model="formData.newPassword"
            name="newPassword"
            label="新密码"
            type="password"
            placeholder="请输入6-16位密码"
            clearable
            maxlength="16"
            @blur="checkPwdLength"
            required
            :rules="[{ required: true,  trigger: 'blur' }]"
        />

        <!-- 确认新密码：第二步才显示 -->
        <van-field
            v-if="step === 2"
            v-model="formData.confirmPassword"
            name="confirmPassword"
            label="确认新密码"
            type="password"
            placeholder="请再次输入新密码"
            clearable
            maxlength="16"
            required
            @blur="checkPwdSame"
            :rules="[{ required: true, trigger: 'blur' }]"
        />

        <!-- 红色提示字：第二步才显示 -->
        <div v-if="step === 2" class="pwd-tips">重置密码成功后需要重新登录</div>

        <!-- 提交按钮：根据步骤切换文字，保留原有样式 -->
        <van-button
            class="submit-btn"
            round
            block
            type="info"
            native-type="submit"
            :loading="isSubmitting"
            style="margin-top: 24px;"
        >
          {{ step === 1 ? '下一步' : '确认重置' }}
        </van-button>
      </van-form>
    </div>
  </div>
</template>

<script>
import '@/assets/css/mobileGlobal.scss';
import { Dialog, Toast } from "vant";
// 导入验证码验证接口+密码重置接口，区分两步逻辑
import { sendCode, updatePasswordToVerify, updatePassword } from "@/api/sales";

export default {
  name: "ForgotPasswordPage",
  data() {
    return {
      step: 1, // 1-手机号验证码步骤 2-设置新密码步骤（核心状态）
      formData: {
        phoneNumber: "",
        code: "",
        newPassword: "",
        confirmPassword: ""
      },
      isSubmitting: false,
      // mobileReg: /^1[3-9]\d{9}$/,
      mobileReg: /^(?:(?:\+|00)86)?1[3-9]\d{9}$|^(?:\+|00)852[569]\d{7}$|^(?:\+|00)8536\d{7}$|^(?:\+|00)8869\d{8}$/,
      countDown: 0,
      timer: null,
      isPwdLegal: false // 标记新密码是否合法，仅第二步生效
    };
  },
  computed: {
    // 手机号合法性校验：始终生效
    isMobileValid() {
      return this.mobileReg.test(this.formData.phoneNumber);
    }
  },
  methods: {
    onPhoneBlur() {
      if(this.formData.phoneNumber){
        const reg =  /^(?:(?:\+|00)86)?1[3-9]\d{9}$|^(?:\+|00)852[569]\d{7}$|^(?:\+|00)8536\d{7}$|^(?:\+|00)8869\d{8}$/;
        const flag = reg.test(this.formData.phoneNumber);
        if (!flag) {
          this.isMobileValid = false;
          Toast('请输入合法的手机号!');
        }else{
          this.isMobileValid = true;
        }
      }

    },
    // 新密码失焦校验：仅第二步显示字段，自然仅第二步触发
    checkPwdLength() {
      const trimNewPwd = this.formData.newPassword.trim();
      if (trimNewPwd.length >= 6 && trimNewPwd.length <= 16) {
        this.isPwdLegal = true;
        return true;
      }
      this.isPwdLegal = false;
      Toast("新密码为6-16位字符，请重新输入");
      return false;
    },

    // 确认密码失焦校验：仅第二步触发
    checkPwdSame() {
      if (!this.isPwdLegal) {
        Toast("请先输入合法的新密码");
        return false;
      }
      const trimConfirmPwd = this.formData.confirmPassword.trim();
      const trimNewPwd = this.formData.newPassword.trim();
      if (trimConfirmPwd === trimNewPwd) {
        return true;
      }
      Toast("两次输入的密码不一致，请重新输入");
      return false;
    },

    // 获取验证码：始终生效，逻辑不变
    // 获取验证码：始终生效，逻辑不变（第二步按钮已隐藏，不会触发）
    async getVerifyCode() {
      if (!this.isMobileValid) {
        Toast("请输入正确的手机号");
        return;
      }
      try {
        // 传update标识区分忘记密码场景（和你之前的验证页一致）
        const res = await sendCode(this.formData.phoneNumber, 'update');
        if (res.code === 200) {
          Toast("验证码已发送，请注意查收");
          this.countDown = 60;
          this.timer = setInterval(() => {
            this.countDown--;
            if (this.countDown <= 0) {
              clearInterval(this.timer);
              this.timer = null;
            }
          }, 1000);
        } else {
          Dialog.alert({ title: '提示', message: res.returnMsg || '获取验证码失败' });
        }
      } catch (error) {
        Toast(error.message || '网络异常，请稍后再试');
      }
    },

    // 提交方法：根据步骤分逻辑处理（核心改造）
    async onSubmit() {
      if (this.isSubmitting) return;
      this.isSubmitting = true;

      try {
        // 步骤1：校验手机号+验证码，调用验证码验证接口
        if (this.step === 1) {
          // 先做Vant表单自带校验（手机号+验证码）
          await this.$refs.forgotPwdForm.validate(['phoneNumber', 'code']);
          if (!this.isMobileValid) {
            Toast("请输入合法的手机号");
            return;
          }
          // 调用验证码验证接口，校验验证码是否正确
          const verifyRes = await updatePasswordToVerify({
            phoneNumber: this.formData.phoneNumber,
            captcha: this.formData.code
          });
          if (verifyRes.code === 200) {
            Toast.success("验证通过，请设置新密码");
            this.step = 2; // 验证通过，切到第二步
          } else {
            Dialog.alert({
              title: '提示',
              message: verifyRes.returnMsg || '验证码错误，请重新输入'
            });
          }
        }
        // 步骤2：校验密码，调用密码重置接口（复用原有逻辑）
        else if (this.step === 2) {
          // 校验新密码长度
          const trimNewPwd = this.formData.newPassword.trim();
          if (trimNewPwd.length < 6 || trimNewPwd.length > 16) {
            Toast("新密码为6-16位字符，请重新输入");
            return;
          }
          // 校验两次密码一致性
          const trimConfirmPwd = this.formData.confirmPassword.trim();
          if (trimNewPwd !== trimConfirmPwd) {
            Toast("两次输入的密码不一致，请重新输入");
            return;
          }
          // 调用密码重置接口
          const resetRes = await updatePassword({
            phoneNumber: this.formData.phoneNumber,
            password: trimNewPwd,
          });
          if (resetRes.code === 200) {
            Toast.success("密码重置成功，请重新登录");
            setTimeout(() => {
              this.$router.push('app_login'); // 跳转登录页
            }, 1000);
          } else {
            Toast(resetRes.returnMsg || "密码重置失败");
          }
        }
      } catch (error) {
        // 捕获表单校验失败/网络错误
        if (error.name === 'ValidateError') {
          Toast.warning("请检查手机号和验证码填写是否正确");
        } else {
          Toast(error.message || '网络异常，请稍后再试');
        }
      } finally {
        this.isSubmitting = false; // 无论成功失败，关闭loading
      }
    },

    // 优化返回按钮体验：第二步返回第一步，第一步返回上一页
    onClickLeft() {
      if (this.step === 2) {
        this.step = 1; // 切回第一步，保留手机号（用户无需重新输入）
        Toast.info("已返回验证步骤");
      } else {
        this.$router.go(-1); // 第一步直接返回上一页（如登录页）
      }
    }
  },
  // 销毁前清除定时器，防止内存泄漏
  beforeDestroy() {
    if (this.timer) clearInterval(this.timer);
  }
};
</script>

<style scoped lang="scss">
.top-bar {
  background: linear-gradient(135deg, #D4AF37 0%, #B8860B 100%);
  ::v-deep {
    .van-icon-arrow-left, .van-nav-bar__text {
      color: #0f0f0f !important;
    }
    .van-nav-bar__title {
      color: #0f0f0f;
      font-weight: 500;
    }
  }
}

.form-wrap {
  padding: 15px;
  background: #f9f9f9;
  border-radius: 8px;
  margin: 15px;
}

.phone-tip {
  font-size: 12px;
  color: #999;
  margin: 8px 0 4px 0;
  padding-left: 4px;
  @media (min-width: 768px) {
    font-size: 15px;
    margin: 5px 0;
  }
}

.pwd-tips {
  color: #f53f3f;
  font-size: 12px;
  text-align: center;
  line-height: 1.5;
  font-weight: bold;
  padding-top: 15px;
  @media (min-width: 768px) {
    font-size: 25px;
    padding-top: 0;
  }
}

.submit-btn {
  background: linear-gradient(135deg, #D4AF37 0%, #B8860B 100%);
  border: none;
  color: #000;
  font-weight: 500;
}

.code-btn {
  background: linear-gradient(135deg, #D4AF37 0%, #B8860B 100%);
  border: none;
  color: #000;
  font-weight: 500;
  height: 32px;
  line-height: 32px;
  font-size: 12px;
  // PC端验证码按钮文字适配
  @media (min-width: 768px) {
    font-size: 14px;
    height: 42px;
    line-height: 42px;
    //top: -30px;
  }
}

::v-deep .van-field__label{
  @media (min-width: 768px) {
    width: 80px;
  }
}

::v-deep .van-field__control {
  height: 44px;
  line-height: 44px;
  font-size: 14px; // 移动端输入文字大小
  flex: 1;
  // PC端输入框内容文字适配
  @media (min-width: 768px) {
    font-size: 15px; // PC端输入文字放大
    height: 42px;
    line-height: 42px;
  }
}

// PC端占位符文字适配
::v-deep .van-field__control::placeholder {
  font-size: 14px;
  @media (min-width: 768px) {
    font-size: 15px;
    color: #aaa; // 提亮占位符，PC端更易识别
  }
}

::v-deep .van-field__button {
  height: 44px;
  display: flex;
  align-items: center;
  padding: 0 8px;
  flex-shrink: 0;
  @media (min-width: 768px) {
    height: 42px; // 匹配PC端输入框高度
  }
}
</style>
